/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель информации о днях доставки
   */
  app.DeliveryDay = app.Model.extend({
    parse: function (resp, options) {
      if (resp.date) {
        resp.date = moment(new Date(resp.date)).format('DD.MM.YYYY');
      }
      return app.Model.prototype.parse.apply(this, [resp, options]);
    }
  });
})();

}.call(window));